import React from 'react'
import { makeStyles, TableRow } from '@material-ui/core'
import { reduceToSumOfItems, sum } from '../../../util/array-utility'
import { formatEnergy, formatPower } from '../../../util/formatters'
import { TableTitleCell } from '../../common/TableTitleCell'
import { TableValueCell } from '../../common/TableValueCell'

type Props = {
  title: string
  firstResultValues?: number[][]
  secondResultValues?: number[][]
  highlightRow?: boolean
  omitPower?: boolean
  omitEnergy?: boolean
  show?: boolean
}

const useStyles = makeStyles(() => ({
  hiddenRow: {
    display: 'none',
  },
}))

export function ReportDualEnergyAndPowerRow({
  title,
  firstResultValues,
  secondResultValues,
  highlightRow = false,
  omitPower = false,
  omitEnergy = false,
  show = true,
}: Props): React.ReactElement {
  const classes = useStyles()

  const combinedFirstResultValues =
    firstResultValues && firstResultValues.length > 0
      ? firstResultValues.reduce(reduceToSumOfItems, [])
      : []
  const combinedSecondResultValues =
    secondResultValues && secondResultValues.length > 0
      ? secondResultValues.reduce(reduceToSumOfItems, [])
      : []

  const firstResultValuesTotal =
    combinedFirstResultValues.length > 0
      ? sum(combinedFirstResultValues)
      : undefined
  const firstResultValuesMax =
    combinedFirstResultValues.length > 0
      ? Math.max(...combinedFirstResultValues)
      : undefined

  const secondResultValuesTotal =
    combinedSecondResultValues.length > 0
      ? sum(combinedSecondResultValues)
      : undefined
  const secondResultValuesMax =
    combinedSecondResultValues.length > 0
      ? Math.max(...combinedSecondResultValues)
      : undefined

  return (
    <TableRow className={show ? '' : classes.hiddenRow}>
      <TableTitleCell highlight={highlightRow}>{title}</TableTitleCell>
      <TableValueCell highlight={highlightRow}>
        {!omitEnergy && firstResultValuesTotal
          ? formatEnergy(firstResultValuesTotal, { omitUnit: true })
          : '-'}
      </TableValueCell>
      <TableValueCell highlight={highlightRow}>
        {!omitPower && firstResultValuesMax
          ? formatPower(firstResultValuesMax, { omitUnit: true })
          : '-'}
      </TableValueCell>
      <TableValueCell highlight={highlightRow}>
        {!omitEnergy && secondResultValuesTotal
          ? formatEnergy(secondResultValuesTotal, { omitUnit: true })
          : '-'}
      </TableValueCell>
      <TableValueCell highlight={highlightRow}>
        {!omitPower && secondResultValuesMax
          ? formatPower(secondResultValuesMax, { omitUnit: true })
          : '-'}
      </TableValueCell>
    </TableRow>
  )
}
